<small class="text-message-error" id="text-message-error">
    {{ text }}
</small>